<template>
    <div id="wrapper">
        <SidebarView :roTransfer="true" :members="true" :memberVisible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />

                <div class="container-fluid">
                    <div class="row">
                        <div class="py-3 d-flex flex-row align-items-center justify-content-between">
                            <div class="col-12">
                                <div class="card card-shape home-box">
                                    <div class="card-header d-flex flex-row align-items-center">
                                        <h6 class="m-0 fw-bold text-green">Transfer Ro</h6>
                                    </div>
                                    <div class="card-body">
                                        <form class="form" @submit.prevent="storeData">
                                            <div class="row mt-2">
                                                <div class="col">
                                                    <b-form-group>
                                                        <label class="akkurate-dark small" for="from_ro">Ro From
                                                            <star></star>
                                                        </label>
                                                        <multiselect v-model="form.ro_from" name="from_ro"
                                                            :options="users" class="mt-2 field-container" label="id"
                                                            :custom-label="customLabel" required>
                                                        </multiselect>
                                                        <errors v-if="form.errors.from_coa">
                                                            {{ form.errors.from_coa[0] }}
                                                        </errors>
                                                    </b-form-group>
                                                </div>

                                                <div class="col">
                                                    <b-form-group>
                                                        <label class="akkurate-dark small" for="to_ro">Ro To
                                                            <star></star>
                                                        </label>
                                                        <multiselect v-model="form.ro_to" name="to_ro" :options="users"
                                                            class="mt-2 field-container" label="id"
                                                            :custom-label="customLabel" required>
                                                        </multiselect>
                                                        <errors v-if="form.errors.to_coa">
                                                            {{ form.errors.to_coa[0] }}
                                                        </errors>
                                                    </b-form-group>
                                                </div>


                                            </div>
                                            <!-- <hr class="my-4" /> -->
                                            <!-- Displaying Total Debit and Total Credit -->

                                            <p class="akkurate-danger small">{{ acc_error }}</p>
                                            <hr />
                                            <div class="text-center py-3">
                                                <SaveButton :isSaving="isSaving" />
                                                <button type="reset" @click="resetForm"
                                                    class="btn akkurate-gray-btn text-white btn-size my-2 ms-3">
                                                    <font-awesome-icon class="me-2" :icon="['fas', 'rotate-right']" />
                                                    Reset
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import Multiselect from 'vue-multiselect';
import ApiService from "@/core/services/api.service";
import SaveButton from "@/views/main/components/SaveButton.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
    name: 'COAReconciliationEntry',
    components: {
        SidebarView,
        TopbarView,
        Footer,
        Multiselect,
        SaveButton,
        ChatBot,
    },
    mounted() {
        this.customer_dropdown();
    },
    data() {
        return {
            ...this.initialState(),
            users: [],
            errors: [],
            isSaving: false,
            acc_error: "",
        }
    },
    methods: {


        customer_dropdown() {
            this.isSaving = true;
            this.$Progress.start();
            ApiService.get("/customers/dropdown")
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.users = response.data.users
                })

        },

        storeData() {
            this.isSaving = true;
            this.$Progress.start();
            const data = {
                data: [
                    {
                        'ro_from': this.form.ro_from?.id,
                        'ro_to': this.form.ro_to?.id,
                    }
                ]

            }
            ApiService.put("/customers/transfer-ro", data)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();

                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });

                    this.resetForm();
                })
                .catch((error) => {
                    console.log(error);
                    this.isSaving = false;
                    this.$Progress.fail();
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors;
                    }
                });
        },
        resetForm() {
            this.form = this.initialState().form;
            // this.entities =, [{ amount: "", coa_subhead: { id: "", name: "", code: "" } }];
            // this.selectedCoaSubhead = this.initialState().selectedCoaSubhead;
            this.errors = [];
        },
        initialState() {
            return {
                form: {
                    ro_from: [],
                    ro_to: [],
                    errors: [],
                },
            }
        },
        customLabel({ id, first_name, surname, branch }) {
            return `${id} - ${first_name} ${surname} - (${branch?.name ?? ""})`
        }
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>